import { List } from 'lodash';
import { Base } from './base';

export class FineResponse extends Base {
   Script: string;
   Image: List<any>;
}
